import CreateScenario from './create-scenario-template'
import DmsDataImport from './dms-data-import'
import RatePrepareProposal from './rate-prepare-proposal'
import SpaceReportGenerate from './space-report-generate'
import { Template } from './template'

const LOOKUP: {
  [TId in Template.Id]: Template<TId>
} = {
  [Template.Id.DmsDataImport]: DmsDataImport,
  [Template.Id.RatePrepareProposal]: RatePrepareProposal,
  [Template.Id.CreateScenario]: CreateScenario,
  [Template.Id.SpaceReportGenerate]: SpaceReportGenerate,
}

/**
 * Retrieves the {@link Template} that has the given {@link Template.Id}.
 *
 * Returns `undefined` when the id does not match any known template — this
 * can happen when historical process records reference templates that have
 * since been removed (e.g., `'rate-apply-rules'` was merged into
 * `'rate-prepare-proposal'`).
 */
export function get<TId extends Template.Id>(
  id: TId,
): Template<TId> | undefined {
  return LOOKUP[id]
}

export { DmsDataImport, Template }
